<ng-container [ngSwitch]="version">
	<ng-container *ngSwitchCase="CustomTimelineVersion.version_1">
		<div class="bg-[url('/assets/images/svgs/hero-bg-pattern.svg')] pt-[48px] px-[32px] pb-[67px] min-h-screen">
			<div class="flex justify-center">
				<img *ngIf="useMoniepointMfbLogo else defaultLogo" src="assets/images/svgs/mp-logo-mfb-white.svg" />

				<ng-template #defaultLogo>
					<img src="assets/images/svgs/desktop-logo-form-icon.svg" />
				</ng-template>
			</div>
			<div class="mt-[48px]">
				<div class="w-full flex items-center">
					<button (click)="previousRoute()" *ngIf="showBackButton" class="mr-[15px]">
						<svg fill="none" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_4751_215973)">
								<path
									d="M17.8125 8.31241H4.54813L10.3431 2.51741C10.8063 2.05429 10.8063 1.29429 10.3431 0.831164C10.2333 0.721078 10.1028 0.63374 9.95912 0.57415C9.81546 0.51456 9.66146 0.483887 9.50594 0.483887C9.35041 0.483887 9.19642 0.51456 9.05276 0.57415C8.9091 0.63374 8.77861 0.721078 8.66875 0.831164L0.843127 8.65679C0.733042 8.76665 0.645704 8.89714 0.586113 9.0408C0.526523 9.18445 0.49585 9.33845 0.49585 9.49398C0.49585 9.6495 0.526523 9.8035 0.586113 9.94716C0.645704 10.0908 0.733042 10.2213 0.843127 10.3312L8.66875 18.1568C8.77869 18.2667 8.90921 18.3539 9.05286 18.4134C9.1965 18.4729 9.35046 18.5036 9.50594 18.5036C9.66142 18.5036 9.81538 18.4729 9.95902 18.4134C10.1027 18.3539 10.2332 18.2667 10.3431 18.1568C10.4531 18.0469 10.5403 17.9163 10.5998 17.7727C10.6593 17.629 10.6899 17.4751 10.6899 17.3196C10.6899 17.1641 10.6593 17.0102 10.5998 16.8665C10.5403 16.7229 10.4531 16.5924 10.3431 16.4824L4.54813 10.6874H17.8125C18.4656 10.6874 19 10.153 19 9.49992C19 8.84679 18.4656 8.31241 17.8125 8.31241Z"
									fill="white" />
							</g>
							<defs>
								<clipPath id="clip0_4751_215973">
									<rect fill="white" height="19" width="19" />
								</clipPath>
							</defs>
						</svg>
					</button>
					<div class="text-[24px] text-white leading-[29px] font-bold">{{ title }}</div>
				</div>
				<div class="mt-[8px] text-[12px] text-white leading-[15px] font-normal">
					{{ subTitle }}
				</div>
			</div>
			<div class="mt-[32px] kyc-lvl-web flex rounded-[16px] min-h-[494px]"
				style="box-shadow: 0px 1px 2px rgba(3, 97, 240, 0.1)">
				<div class="basis-1/3 bg-white rounded-tl-[16px] px-[24px] rounded-bl-[16px] min-h-[494px]">
					<app-kamona-timeline [stepperBottom]="true" [steps]="steps"></app-kamona-timeline>
				</div>
				<div class="grow right-form">
					<div class="right-form-container mx-auto">
						<div class="text-[24px] leading-[29px] text-black font-bold">
							{{ formTitle }}
						</div>
						<div class="text-[14px] mt-[4px] text-black/90 leading-[20px] font-normal">
							{{ formSubTitle }}
						</div>
						<div class="web-timeline-wrapper">
              <ng-container *ngTemplateOutlet="ngContent"></ng-container>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="CustomTimelineVersion.version_2">
		<div class="bg-[url('/assets/images/svgs/hero-bg-pattern.svg')] flex flex-col min-h-screen py-[81px] px-[32px]">
			<div class="flex justify-center">
				<svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
					<g clip-path="url(#clip0_2_464645)">
						<g clip-path="url(#clip1_2_464645)">
							<path clip-rule="evenodd"
								d="M23.832 48H24.0034C35.0907 48 42.5204 45.6774 44.0635 44.215C45.6923 42.7527 47.8354 35.1541 47.8354 24C47.8354 12.8459 45.6923 5.24729 44.0635 3.78492C42.5204 2.35123 35.0907 0.0286509 24.0034 -2.28882e-05H23.832C12.7733 0.0286509 5.31505 2.35123 3.77197 3.78492C2.14316 5.24729 0 12.8459 0 24C0 35.1828 2.14316 42.7527 3.77197 44.215C5.31505 45.6487 12.7447 47.9713 23.832 48ZM34.0329 14.2223L34.9473 25.4337L35.576 33.8065H32.2041C30.7753 33.8065 30.1752 33.1757 30.0609 31.6273L29.5751 21.276H29.518C29.1179 22.7957 25.9746 30.3943 25.9746 30.3943H21.8312C21.8312 30.3943 18.6879 22.681 18.4593 21.8782L18.2878 21.276H18.2307C18.3164 22.595 17.7449 31.6273 17.7449 31.6273C17.6306 33.1757 17.0591 33.8065 15.6017 33.8065H12.2298L13.0014 23.9427L13.9158 14.2223H19.4594L23.8886 24.0287H23.9458C24.3173 22.8531 28.5179 14.2223 28.5179 14.2223H34.0329Z"
								fill="white" fill-rule="evenodd" />
						</g>
					</g>
					<defs>
						<clipPath id="clip0_2_464645">
							<rect fill="white" height="48" width="48" />
						</clipPath>
						<clipPath id="clip1_2_464645">
							<rect fill="white" height="48" width="48" />
						</clipPath>
					</defs>
				</svg>
			</div>
			<div class="mt-[19px] text-center font-bold text-[32px] leading-[39px] text-white">
				{{ title }}
			</div>
			<div class="version-II-wrapper relative">
				<ng-content select="[contentV2]"></ng-content>
			</div>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="CustomTimelineVersion.version_3">
		<div
			class="bg-[url('/assets/images/svgs/hero-bg-pattern.svg')] flex flex-col relative min-h-screen py-[58px] px-[32px]">
			<div class="flex justify-center">
				<svg fill="none" height="44" viewBox="0 0 186 44" width="186" xmlns="http://www.w3.org/2000/svg">
					<g clip-path="url(#clip0_19621_268717)">
						<g clip-path="url(#clip1_19621_268717)">
							<path
								d="M79.1385 19.6341C80.5793 18.3462 82.3403 17.7153 84.4482 17.7153C86.5827 17.7153 88.3438 18.3462 89.7846 19.6341C91.2254 20.8957 91.9458 22.5517 91.9458 24.5755C91.9458 26.5732 91.2254 28.2291 89.7846 29.4907C88.3704 30.7261 86.6094 31.3569 84.4749 31.3569C82.3403 31.3569 80.5793 30.7261 79.1385 29.4907C77.7243 28.2291 77.0039 26.5732 77.0039 24.5755C77.0039 22.5517 77.7243 20.8957 79.1385 19.6341ZM84.4749 27.7034C86.1558 27.7034 87.4899 26.468 87.4899 24.5755C87.4899 22.6568 86.1558 21.3689 84.4749 21.3689C82.7939 21.3689 81.4598 22.6568 81.4598 24.5755C81.4598 26.468 82.8206 27.7034 84.4749 27.7034Z"
								fill="white" />
							<path
								d="M102.006 17.7153C100.138 17.7153 98.7239 18.4776 97.8167 19.9758H97.7633L97.79 19.6604V19.4764C97.79 18.5564 97.1496 18.0045 95.9489 18.0045H92V21.6843H92.9872C93.3875 21.6843 93.5476 21.8683 93.5476 22.2362V31.0415H98.0034V25.2589C98.0034 24.6018 98.0835 24.0236 98.2703 23.5505C98.6972 22.3151 99.5777 21.6843 100.885 21.6843C101.872 21.6843 102.353 22.2625 102.353 23.3928V29.2016C102.353 30.4895 102.913 31.0415 104.22 31.0415H106.782V22.6042C106.782 19.3187 105.181 17.7153 102.006 17.7153Z"
								fill="white" />
							<path
								d="M109.956 12.958V16.5064H113.691V12.958H109.956ZM112.197 18.0046H108.088V21.6844H109.075C109.449 21.6844 109.635 21.8684 109.635 22.2364V29.2017C109.635 30.4897 110.196 31.0416 111.503 31.0416H114.065V19.8708C114.065 18.5566 113.504 18.0046 112.197 18.0046Z"
								fill="white" />
							<path
								d="M117.507 19.6604C118.761 18.3724 120.442 17.7153 122.523 17.7153C124.418 17.7153 125.912 18.2936 127.006 19.4764C128.1 20.6329 128.66 22.1574 128.66 23.9973C128.66 24.3127 128.633 24.7595 128.553 25.3641H120.202C120.522 26.8886 121.776 27.7034 123.297 27.7034C124.391 27.7034 125.618 27.2828 126.952 26.3892L128.607 29.4644C127.193 30.6472 125.005 31.3569 122.95 31.3569C120.709 31.3569 118.948 30.6735 117.64 29.333C116.333 27.9925 115.693 26.3629 115.693 24.523C115.639 22.5779 116.253 20.9483 117.507 19.6604ZM124.258 22.8671C124.258 21.7631 123.537 20.922 122.443 20.922C121.323 20.922 120.602 21.5791 120.309 22.8671H124.258Z"
								fill="white" />
							<path
								d="M130.234 18.2412H132.556V19.3714C132.556 19.8971 132.476 20.3439 132.476 20.3439H132.529C133.356 18.7932 135.01 17.9258 136.905 17.9258C140.427 17.9258 142.615 20.6594 142.615 24.6283C142.615 28.7024 140.133 31.3308 136.718 31.3308C135.064 31.3308 133.57 30.516 132.689 29.1492H132.636C132.636 29.1492 132.742 29.596 132.742 30.2531V36.0883H130.261V18.2412H130.234ZM136.345 29.228C138.399 29.228 140.107 27.5721 140.107 24.6809C140.107 21.8947 138.586 20.1074 136.425 20.1074C134.477 20.1074 132.662 21.4742 132.662 24.7071C132.662 26.9676 133.943 29.228 136.345 29.228Z"
								fill="white" />
							<path
								d="M150.805 17.9258C154.701 17.9258 157.823 20.7382 157.823 24.602C157.823 28.4921 154.674 31.3308 150.832 31.3308C146.936 31.3308 143.814 28.4921 143.814 24.602C143.814 20.7382 146.963 17.9258 150.805 17.9258ZM150.832 29.228C153.287 29.228 155.314 27.3093 155.314 24.6283C155.314 21.9736 153.287 20.0811 150.832 20.0811C148.35 20.0811 146.349 21.9736 146.349 24.6283C146.376 27.3093 148.377 29.228 150.832 29.228Z"
								fill="white" />
							<path
								d="M159.771 13.1685H162.333V15.6392H159.771V13.1685ZM159.825 18.2413H162.306V31.0681H159.825V18.2413Z"
								fill="white" />
							<path
								d="M165.107 18.2412H167.535V19.976C167.535 20.5017 167.455 20.9485 167.455 20.9485H167.509C167.989 19.8445 169.59 17.9258 172.445 17.9258C175.513 17.9258 176.901 19.5817 176.901 22.841V31.0417H174.419V23.3929C174.419 21.6056 174.073 20.1862 171.965 20.1862C169.43 20.1862 167.616 22.2627 167.616 24.8911V31.0417H165.134V18.2412H165.107Z"
								fill="white" />
							<path
								d="M180.13 20.3704H178.422V18.3728H180.183V14.7192H182.638V18.3728H185.786V20.3704H182.638V26.1004C182.638 28.6499 184.452 28.9916 185.413 28.9916C185.599 28.9916 185.759 28.9916 186 28.9391V31.1207C185.786 31.147 185.519 31.1995 185.119 31.1995C183.438 31.1995 180.13 30.6738 180.13 26.3895V20.3704Z"
								fill="white" />
							<path
								d="M75.5897 23.314L74.7359 12.958H69.5329C69.5329 12.958 65.5573 20.9485 65.2371 22.0261H65.1838L61.0214 12.958H55.8184L54.9646 21.9473L54.2441 31.0679H57.4193C58.7801 31.0679 59.3404 30.4897 59.4471 29.0703C59.4471 29.0703 59.9808 20.7119 59.9007 19.5028H59.9541L60.1142 20.0548C60.3276 20.7907 63.2893 27.9138 63.2893 27.9138H67.1849C67.1849 27.9138 70.1466 20.8959 70.5201 19.5028H70.5735L71.0271 29.0703C71.1338 30.4897 71.6942 31.0679 73.0549 31.0679H76.2301L75.5897 23.314Z"
								fill="white" />
							<path clip-rule="evenodd"
								d="M22.2528 44H22.4129C32.7655 44 39.7028 41.871 41.1436 40.5305C42.6645 39.19 44.6656 32.2246 44.6656 22C44.6656 11.7754 42.6645 4.81004 41.1436 3.46953C39.7028 2.15532 32.7655 0.0262844 22.4129 0H22.2528C11.9268 0.0262844 4.96285 2.15532 3.52202 3.46953C2.00115 4.81004 0 11.7754 0 22C0 32.2509 2.00115 39.19 3.52202 40.5305C4.96285 41.8447 11.9002 43.9737 22.2528 44ZM31.7775 13.0371L32.6313 23.3142L33.2183 30.9893H30.0699C28.7358 30.9893 28.1755 30.411 28.0687 28.9917L27.6151 19.503H27.5618C27.1882 20.8961 24.2532 27.8614 24.2532 27.8614H20.3843C20.3843 27.8614 17.4493 20.7909 17.2359 20.055L17.0758 19.503H17.0224C17.1024 20.7121 16.5688 28.9917 16.5688 28.9917C16.4621 30.411 15.9284 30.9893 14.5677 30.9893H11.4192L12.1396 21.9475L12.9934 13.0371H18.1697L22.3054 22.0263H22.3588C22.7057 20.9486 26.6279 13.0371 26.6279 13.0371H31.7775Z"
								fill="white" fill-rule="evenodd" />
						</g>
					</g>
					<defs>
						<clipPath id="clip0_19621_268717">
							<rect fill="white" height="44" width="186" />
						</clipPath>
						<clipPath id="clip1_19621_268717">
							<rect fill="white" height="44" width="186" />
						</clipPath>
					</defs>
				</svg>
			</div>
			<div class="version-III-wrapper relative">
				<ng-content select="[contentV3]"></ng-content>
			</div>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="CustomTimelineVersion.version_4">
		<div class="bg-[url('/assets/images/svgs/hero-bg-pattern.svg')] flex flex-col min-h-screen px-[32px]">
			<app-sign-up-v3-header></app-sign-up-v3-header>
			<div class="py-[81px]">
				<div class="flex justify-center">
					<svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_2_464645)">
							<g clip-path="url(#clip1_2_464645)">
								<path clip-rule="evenodd"
									d="M23.832 48H24.0034C35.0907 48 42.5204 45.6774 44.0635 44.215C45.6923 42.7527 47.8354 35.1541 47.8354 24C47.8354 12.8459 45.6923 5.24729 44.0635 3.78492C42.5204 2.35123 35.0907 0.0286509 24.0034 -2.28882e-05H23.832C12.7733 0.0286509 5.31505 2.35123 3.77197 3.78492C2.14316 5.24729 0 12.8459 0 24C0 35.1828 2.14316 42.7527 3.77197 44.215C5.31505 45.6487 12.7447 47.9713 23.832 48ZM34.0329 14.2223L34.9473 25.4337L35.576 33.8065H32.2041C30.7753 33.8065 30.1752 33.1757 30.0609 31.6273L29.5751 21.276H29.518C29.1179 22.7957 25.9746 30.3943 25.9746 30.3943H21.8312C21.8312 30.3943 18.6879 22.681 18.4593 21.8782L18.2878 21.276H18.2307C18.3164 22.595 17.7449 31.6273 17.7449 31.6273C17.6306 33.1757 17.0591 33.8065 15.6017 33.8065H12.2298L13.0014 23.9427L13.9158 14.2223H19.4594L23.8886 24.0287H23.9458C24.3173 22.8531 28.5179 14.2223 28.5179 14.2223H34.0329Z"
									fill="white" fill-rule="evenodd" />
							</g>
						</g>
						<defs>
							<clipPath id="clip0_2_464645">
								<rect fill="white" height="48" width="48" />
							</clipPath>
							<clipPath id="clip1_2_464645">
								<rect fill="white" height="48" width="48" />
							</clipPath>
						</defs>
					</svg>
				</div>
				<div class="mt-[19px] text-center font-bold text-[32px] leading-[39px] text-white">
					{{ title }}
				</div>
				<div class="version-II-wrapper relative">
					<ng-content select="[contentV4]"></ng-content>
				</div>
			</div>
		</div>
	</ng-container>
  <ng-container *ngSwitchCase="CustomTimelineVersion.version_5">
    <div class="bg-[url('/assets/images/svgs/hero-bg-pattern.svg')] pt-[48px] px-[32px] pb-[67px] min-h-screen">
      <div class="flex justify-center">
        <img src="assets/images/svgs/desktop-logo-form-icon.svg" />
      </div>
      <div class="mt-[48px]">
        <div class="w-full flex items-center">
          <button (click)="previousRoute()" *ngIf="showBackButton" class="mr-[15px]">
            <svg fill="none" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_4751_215973)">
                <path
                  d="M17.8125 8.31241H4.54813L10.3431 2.51741C10.8063 2.05429 10.8063 1.29429 10.3431 0.831164C10.2333 0.721078 10.1028 0.63374 9.95912 0.57415C9.81546 0.51456 9.66146 0.483887 9.50594 0.483887C9.35041 0.483887 9.19642 0.51456 9.05276 0.57415C8.9091 0.63374 8.77861 0.721078 8.66875 0.831164L0.843127 8.65679C0.733042 8.76665 0.645704 8.89714 0.586113 9.0408C0.526523 9.18445 0.49585 9.33845 0.49585 9.49398C0.49585 9.6495 0.526523 9.8035 0.586113 9.94716C0.645704 10.0908 0.733042 10.2213 0.843127 10.3312L8.66875 18.1568C8.77869 18.2667 8.90921 18.3539 9.05286 18.4134C9.1965 18.4729 9.35046 18.5036 9.50594 18.5036C9.66142 18.5036 9.81538 18.4729 9.95902 18.4134C10.1027 18.3539 10.2332 18.2667 10.3431 18.1568C10.4531 18.0469 10.5403 17.9163 10.5998 17.7727C10.6593 17.629 10.6899 17.4751 10.6899 17.3196C10.6899 17.1641 10.6593 17.0102 10.5998 16.8665C10.5403 16.7229 10.4531 16.5924 10.3431 16.4824L4.54813 10.6874H17.8125C18.4656 10.6874 19 10.153 19 9.49992C19 8.84679 18.4656 8.31241 17.8125 8.31241Z"
                  fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_4751_215973">
                  <rect fill="white" height="19" width="19" />
                </clipPath>
              </defs>
            </svg>
          </button>
          <div class="text-[24px] text-white leading-[29px] font-bold">{{ title }}</div>
        </div>
        <div class="mt-[8px] text-[12px] text-white leading-[15px] font-normal">
          {{ subTitle }}
        </div>
      </div>
      <div class="mt-[32px] kyc-lvl-web flex rounded-[16px] min-h-[494px]"
           style="box-shadow: 0px 1px 2px rgba(3, 97, 240, 0.1)">
        <div class="basis-1/3 bg-white rounded-tl-[16px] px-[24px] rounded-bl-[16px] min-h-[494px]">
          <app-kamona-timeline [stepperBottom]="true" [steps]="steps"></app-kamona-timeline>
        </div>
        <div class="grow bg-[#F2F7FE] rounded-tr-[16px] rounded-br-[16px]">
          <div class="mx-auto">
            <div class="text-[24px] leading-[29px] text-black font-bold">
              {{ formTitle }}
            </div>
            <div class="text-[14px] mt-[4px] text-black/90 leading-[20px] font-normal">
              {{ formSubTitle }}
            </div>
            <div>
              <ng-container *ngTemplateOutlet="ngContent"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="CustomTimelineVersion.version_6">
    <div class="bg-[url('/assets/images/svgs/hero-bg-pattern.svg')] pt-[48px] px-[32px] pb-[67px] min-h-screen">
      <div class="flex justify-center">
        <img src="assets/images/svgs/desktop-logo-form-icon.svg" />
      </div>
      <div class="mt-[48px]">
        <div class="w-full flex items-center">
          <button (click)="previousRoute()" *ngIf="showBackButton" class="mr-[15px]">
            <svg fill="none" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_4751_215973)">
                <path
                  d="M17.8125 8.31241H4.54813L10.3431 2.51741C10.8063 2.05429 10.8063 1.29429 10.3431 0.831164C10.2333 0.721078 10.1028 0.63374 9.95912 0.57415C9.81546 0.51456 9.66146 0.483887 9.50594 0.483887C9.35041 0.483887 9.19642 0.51456 9.05276 0.57415C8.9091 0.63374 8.77861 0.721078 8.66875 0.831164L0.843127 8.65679C0.733042 8.76665 0.645704 8.89714 0.586113 9.0408C0.526523 9.18445 0.49585 9.33845 0.49585 9.49398C0.49585 9.6495 0.526523 9.8035 0.586113 9.94716C0.645704 10.0908 0.733042 10.2213 0.843127 10.3312L8.66875 18.1568C8.77869 18.2667 8.90921 18.3539 9.05286 18.4134C9.1965 18.4729 9.35046 18.5036 9.50594 18.5036C9.66142 18.5036 9.81538 18.4729 9.95902 18.4134C10.1027 18.3539 10.2332 18.2667 10.3431 18.1568C10.4531 18.0469 10.5403 17.9163 10.5998 17.7727C10.6593 17.629 10.6899 17.4751 10.6899 17.3196C10.6899 17.1641 10.6593 17.0102 10.5998 16.8665C10.5403 16.7229 10.4531 16.5924 10.3431 16.4824L4.54813 10.6874H17.8125C18.4656 10.6874 19 10.153 19 9.49992C19 8.84679 18.4656 8.31241 17.8125 8.31241Z"
                  fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_4751_215973">
                  <rect fill="white" height="19" width="19" />
                </clipPath>
              </defs>
            </svg>
          </button>
          <div class="text-[24px] text-white leading-[29px] font-bold">{{ title }}</div>
        </div>
        <div class="mt-[8px] text-[12px] text-white leading-[15px] font-normal">
          {{ subTitle }}
        </div>
      </div>
      <div class="mt-[32px] kyc-lvl-web flex rounded-[16px] min-h-[494px]"
           style="box-shadow: 0px 1px 2px rgba(3, 97, 240, 0.1)">
        <div class="basis-1/3 bg-white rounded-tl-[16px] px-[24px] rounded-bl-[16px] min-h-[494px]">
          <app-kamona-timeline [stepperBottom]="true" [steps]="steps"></app-kamona-timeline>
        </div>
        <div class="grow right-form">
          <div class="right-form-container mx-auto !bg-[#F2F7FE]">
            <div class="text-[24px] leading-[29px] text-black font-bold">
              {{ formTitle }}
            </div>
            <div class="text-[14px] mt-[4px] text-black/90 leading-[20px] font-normal">
              {{ formSubTitle }}
            </div>
            <div class="web-timeline-wrapper !bg-white">
              <ng-container *ngTemplateOutlet="ngContent"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="CustomTimelineVersion.version_7">
	<div class="mt-[32px] kyc-lvl-web flex rounded-[16px] min-h-[494px]"
		style="box-shadow: 0px 1px 2px rgba(3, 97, 240, 0.1)">
		<div class="basis-1/3 bg-white rounded-tl-[16px] px-[24px] rounded-bl-[16px] min-h-[494px]">
			<app-kamona-timeline [stepperBottom]="true" [steps]="steps"></app-kamona-timeline>
		</div>
		<div class="grow right-form">
			<div class="right-form-container mx-auto !bg-[#F2F7FE]">
				<div class="text-[24px] leading-[29px] text-black font-bold">
					{{ formTitle }}
				</div>
				<div class="text-[14px] mt-[4px] text-black/90 leading-[20px] font-normal">
					{{ formSubTitle }}
				</div>
				<div class="web-timeline-wrapper !bg-white">
					<ng-container *ngTemplateOutlet="ngContent"></ng-container>
				</div>
			</div>
		</div>
	</div>
  </ng-container>
</ng-container>

<ng-template #ngContent>
  <ng-content></ng-content>
</ng-template>
